import * as z from "zod";

export const verifyUspsContractRatesLinked = {
  name: "verifyUspsContractRatesLinked" as const,
  input: z.object({ uspsCarrierAccountIntegrationId: z.string() }),
  output: z.object({
    success: z.boolean(),
    errorMessage: z.string().nullish(),
  }),
};
